export default __webpack_public_path__ + "static/media/binance_logo.06395e34.svg";